const statusColors = {
  pending_authorization: 'var(--color-yellow)',
  sent: 'var(--color-yellow)',
  pending_consent: 'var(--color-yellow)',
  pending: 'var(--color-yellow)',
  in_review: 'var(--color-orange)',
  recalled: 'var(--color-orange)',
  rejection: 'var(--color-red)',
  denied_authorization: 'var(--color-red)',
  declined: 'var(--color-red)',
  closed: 'var(--color-action-blue)',
  declined_consent: 'var(--color-red)',
  open: 'var(--color-dark-green)',
  processed: 'var(--color-medium-grey)',
  accepted: 'var(--color-medium-grey)',
};

export default function getStatusColor(status) {
  return statusColors[status] || 'var(--color-medium-grey)';
}
